<template>
  <div class="side-center-modal side-center-modal-add-editor h-full">
    <div class="container-share-link-audience h-full">
      <div class="share-link_title side-center_title" v-if="isShowShareToEditList">
        <aha-svg
          size="lg"
          name="arrow-tail"
          view-box="0 0 18 19"
          @click="isShowShareToEditList = false"
          class="flex-shrink-0 mr-3 align-middle cursor-pointer back-button"
        />
        {{ $i18nPresenter.t('Invite team members') }}
      </div>
      <ShareToEdit
        :folder="folder"
        :hide-title="true"
        :shareTeam="shareTeam"
        :invitedRole="invitedRole"
        :presentation="presentation"
        v-if="!isShowShareToEditList"
        @handleShowShareToEditList="showShareToEditModal()"
        @prepareDataForInviteTeamModal="prepareDataForInviteTeamModal"
        @changeInvitedRole="changeInvitedRole"
      ></ShareToEdit>

      <ShareToEditList
        :presentation="presentation"
        :folder="folder"
        :invitedRole="invitedRole"
        v-if="isShowShareToEditList"
      />

      <!-- <ShareToTeamForEditMain
        v-if="isShowForTeam"
        :presentation="presentation"
        :teamName="currentAccount.name"
      >
      </ShareToTeamForEditMain> -->
    </div>
  </div>
</template>
<script>

import { mapState, mapActions } from 'vuex'
// import constants from '@/constant'
import ShareToEdit from '@/components-v2/presentation-editor/collaboration/ShareToEdit.vue'
import ShareToEditList from '@/components-v2/modals/ShareToEditList.vue'
// import ShareToTeamForEditMain from '@/components-v2/editor-share-v2/ShareToTeamForEditMain'
import constants from '@/constant'

export default {
  name: 'SideCenterAddEditor',
  components: { /* ShareToTeamForEditMain, */ ShareToEditList, ShareToEdit },
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
    presentation: {
      type: Object,
      default: () => {},
    },
    shareTeam: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowShareToEditList: false,
      invitedRole: constants.role.EDITOR,
    }
  },
  computed: {
    ...mapState({
      currentAccount: (state) => state.currentAccount,
      currentUser: (state) => state.currentUser,
      workingMode: (state) => state.workingMode,
    }),
    isShowForTeam() {
      if (!this.currentUser.accountId) {
        return false
      }
      if (this.folder) {
        return this.folder.accountId === this.currentUser.accountId
      }
      return this.presentation.accountId === this.currentUser.accountId
    },
  },
  mounted() {
    if (this.folder) {
      const canViewerShare = this.folder.ownerId === this.currentUser.id ||
      (this.folder.permissions && this.folder.permissions.includes(constants.permissions.RENAME_PRESENTATION))
      this.setCanViewerShare(canViewerShare)
    }
  },
  methods: {
    ...mapActions([
      'setCanViewerShare',
    ]),
    showShareToEditModal() {
      this.isShowShareToEditList = true
    },
    prepareDataForInviteTeamModal({ toBeInvitedMembers }) {
      this.$emit('prepareDataForInviteTeamModal', { toBeInvitedMembers })
    },
    changeInvitedRole(value) {
      this.invitedRole = value
    },
  },
}
</script>

<style scoped lang="scss">
.side-center-modal-add-editor {
  .side-center_title {
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(0, 0, 0, 1);
    margin-bottom: 12px;
  }
}
</style>
